import React from "react";


interface LogoPrincipalProps extends React.HTMLAttributes<HTMLElement>{

}

class LogoPrincipal extends React.Component<LogoPrincipalProps> {
  render() {
    return(
      <div {...this.props}>
        <img
          src={require('../../assets/Logo.svg').default}
          alt="Logo - SVG"
          width="132"
          height="38"
        />
    </div>
    )
  }
}

export default LogoPrincipal;